
import { Emit, Component, Mixins, Ref, Prop, InjectReactive, Provide, ProvideReactive } from "vue-property-decorator";
import SubSymptomConfig from "./subSymptomConfig.vue";
import TongueAppearance from "./tongueAppearance.vue";


import TablePagination from "@/mixins/tablePagination";
import Resize from "@/mixins/resize";


@Component({ name: 'tongue-components-subSymptom',
    inject: [],
    components: {
        SubSymptomConfig,
        TongueAppearance
    }
})
export default class TongueSubSymptom extends Mixins(Resize, TablePagination) {
    @ProvideReactive() subTabActiveName = "first";

    mounted() {
        this.subTabActiveName = "first";
    }
}
